import { Code, ConnectError } from "@bufbuild/connect";
import { EventRoleAuthorizationError } from "@spwn-portal/grpc";

type EventDashboardPermissionErrorResolution =
  | "none"
  | "redirect"
  | "alternative-event-authorized";

export const isEventDashboardPermissionError = (
  error: unknown
): error is ConnectError =>
  error instanceof ConnectError &&
  (error.code === Code.PermissionDenied || error.code === Code.Unauthenticated);

export const getEventDashboardPermissionErrorResolution = (
  errors: unknown[]
): EventDashboardPermissionErrorResolution => {
  const permissionErrors = errors.filter(isEventDashboardPermissionError);

  if (permissionErrors.length === 0) {
    return "none";
  }

  const hasAlternativeEventAuthorization = permissionErrors.some(
    (error) => error.findDetails(EventRoleAuthorizationError).length > 0
  );

  return hasAlternativeEventAuthorization
    ? "alternative-event-authorized"
    : "redirect";
};
